/**
 * Matemática de retentativa do boot.
 *
 * Extraída do `GlobalLoader` **sem alteração**. Os limites, o backoff e o teto
 * são comportamento que custou a existir e que o redesenho da apresentação não
 * tem motivo para tocar — separá-los é justamente o que permite reescrever a
 * casca e provar que o miolo ficou igual.
 */

/** Backoff exponencial com teto de 30s, a partir da contagem de falhas. */
export const retryDelayMs = (count: number): number =>
  Math.min(1000 * 2 ** count, 30_000)

/**
 * Fase da apresentação. A escalada é por quanto tempo o problema persiste, não
 * por gravidade do erro: rede instável falha uma vez e volta, e roubar a tela
 * por causa disso é desproporcional.
 */
export type BootFailurePhase = 0 | 1 | 2 | 3 | 4

export const getPhase = (failureCount: number): BootFailurePhase => {
  if (failureCount === 0) return 0
  if (failureCount <= 2) return 1
  if (failureCount <= 5) return 2
  if (failureCount <= 8) return 3
  return 4
}

/** Teto de tentativas automáticas. */
export const MAX_RETRIES = 10
